<div #requestCard>
  <div [ngClass]="className"
      id="{{requestDivId}}">

    <div class="request__header">
      <label>
        <span>{{request.requestNumber}}</span>
      </label>

      <label>
        <span><img src="{{getIconName(request.service.code)}}"/></span>
        <span>{{request.service.name}}</span>
      </label>
      <label *ngIf="responsibleUserToCompare === request.responsible.userCode">
        <span class="fa fa-user"></span>
      </label>
    </div>
    <div class="request__content">
      <label>
        <span class="fa fa-map-marker"></span>
        <span>{{request.formattedAddress}}</span>
      </label>
      <label>
        <span class="fa fa-calendar-o"></span>
        <span>{{ request.estimatedCompletionDate | date:'dd MMM yyyy HH:mm' }}</span>
        <span *ngIf="hasDelayOver1Day">- {{'components.requestComponent.delayed' | translate }} {{  delay }} {{'components.requestComponent.days' | translate }}</span>
        <span *ngIf="hasDelayWithin1Day">- {{'components.requestComponent.delayedWithin1Day' | translate }}</span>
      </label>

      <div class="request__content__status">
        <label>
          <span class="fa fa-hourglass-half"></span>
          <span>{{request.status.name}} - {{ request.status.statusDatetime | date:'dd MMM yyyy' }}</span>
        </label>
        <label>
          <span *ngIf="request.isRelaunched">{{ 'components.requestComponent.relaunched' | translate }}</span>
          <span *ngIf="request.isRelaunched && request.isReactivated">&#47;</span>
          <span *ngIf="request.isReactivated">{{ 'components.requestComponent.reactivated' | translate }}</span>
        </label>
      </div>
    </div>

    <ng-container *ngIf="batchMode && batchMode.isActive else singleMode">
      <div class="request__footer" *ngIf="!popupMode && isEditMode">
        <button type="button"
           class="btn btn-default"
           (click)="onSelectInBatch()"
           [disabled]="isRequestInBatchDisabled()">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-check" *ngIf="!request.isSelected"></li>
            <li class="btn-item" *ngIf="!request.isSelected">{{'components.requestComponent.select' | translate}}</li>
            <li class="btn-item-fa fa fa-times" *ngIf="request.isSelected"></li>
            <li class="btn-item" *ngIf="request.isSelected">{{'components.requestComponent.unselect' | translate}}</li>
          </ul>
        </button>
      </div>
    </ng-container>
    <ng-template #singleMode>
      <div class="request__footer" *ngIf="popupMode">
        <div class="btn btn-default closeRequestButton">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-times-circle"></li>
            <li class="btn-item">{{'components.requestComponent.close' | translate}}</li>
          </ul>
        </div>
        <div class="btn btn-default viewRequestButton">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-file-text-o"></li>
            <li class="btn-item">{{'components.requestComponent.details' | translate}}</li>
          </ul>
        </div>
        <div class="btn btn-default editRequestButton">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-pencil-square-o"></li>
            <li class="btn-item">{{'components.requestComponent.actions' | translate}}</li>
          </ul>
        </div>
      </div>
      
      <div class="request__footer" *ngIf="!popupMode && isEditMode">
        <button type="button"
                class="btn btn-default"
                (click)="onTakeInChargeHandle()"
                [disabled]="(request.source |isWorkorderRequest) && (request |isInternalWorkorderRequest) ">
          <ul class="btn-ctn">
            <ng-container *ngIf="!(request.source |isWorkorderRequest)">
              <li class="btn-item-fa fa fa-check"></li>
              <li class="btn-item">{{'components.requestComponent.takeInCharge' | translate}}</li>
            </ng-container>
            <ng-container *ngIf="(request.source |isWorkorderRequest)">
              <li class="btn-item-fa fa fa-times"></li>
              <li class="btn-item">{{'components.requestComponent.cancelTakeInCharge' | translate}}</li>
            </ng-container>
          </ul>
        </button>

        <button type="button"
                class="btn btn-default"
                (click)="closeWorkorder()"
                [disabled]="!(request.source |isWorkorderRequest)">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-times-circle"></li>
            <li class="btn-item">{{'components.requestComponent.close' | translate}}</li>
          </ul>
        </button>
      </div>

      <div class="request__footer"
          *ngIf="!popupMode && isEditMode">
        <button type="button"
                class="btn btn-default"
                (click)="onSelectRequest()">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-map-marker"
                *ngIf="!request.isSelected"></li>
            <li class="btn-item"
                *ngIf="!request.isSelected">{{'components.requestComponent.localize' | translate}}</li>
            <li class="btn-item-fa fa fa-times"
                *ngIf="request.isSelected">
            </li>
            <li class="btn-item"
                *ngIf="request.isSelected">{{'components.requestComponent.delocalize' | translate}}</li>
          </ul>
        </button>

        <button type="button"
                class="btn btn-default"
                (click)="onViewRequest()">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-file-text-o"></li>
            <li class="btn-item">{{'components.requestComponent.details' | translate}}</li>
          </ul>
        </button>

        <button type="button"
                class="btn btn-default"
                (click)="onEditRequest()">
          <ul class="btn-ctn">
            <li class="btn-item-fa fa fa-pencil-square-o"></li>
            <li class="btn-item">{{'components.requestComponent.actions' | translate}}</li>
          </ul>
        </button>
      </div>
    </ng-template>
  </div>
</div>